export default __webpack_public_path__ + "static/media/empty-order.01ebba39.png";